import { GetStaticProps, InferGetStaticPropsType, NextPage } from 'next';

import {
  FooterDocument,
  FooterQuery,
  FooterQueryVariables,
  FormDocument,
  FormQuery,
  FormQueryVariables,
  HomeSeoDocument,
  HomeSeoQuery,
  HomeSeoQueryVariables,
  NavigationDocument,
  NavigationQuery,
  NavigationQueryVariables,
} from '@/api';
import { addApolloState, initializeApollo } from '@/api/apolloClient';
import { Layout } from '@/components/layout/Layout';
import { Seo } from '@/components/Seo';

export const getStaticProps: GetStaticProps = async () => {
  const client = initializeApollo();

  // prefetch
  await client.query({ query: HomeSeoDocument });
  await client.query({ query: FormDocument });
  await client.query({ query: NavigationDocument });
  await client.query({ query: HomeSeoDocument });
  await client.query({ query: FooterDocument });

  const { data: seoData } = await client.query<
    HomeSeoQuery,
    HomeSeoQueryVariables
  >({ query: HomeSeoDocument });

  const { data: formData } = await client.query<FormQuery, FormQueryVariables>({
    query: FormDocument,
  });

  const { data: footerData } = await client.query<
    FooterQuery,
    FooterQueryVariables
  >({ query: FooterDocument });

  const { data: headerData } = await client.query<
    NavigationQuery,
    NavigationQueryVariables
  >({ query: NavigationDocument });

  return addApolloState(client, {
    props: {
      seoData,
      formData,
      footerData,
      headerData,
    },
  });
};

const Contact: NextPage<InferGetStaticPropsType<typeof getStaticProps>> = ({
  seoData,
  formData,
  footerData,
  headerData,
}) => (
  <Layout formData={formData} footerData={footerData} headerData={headerData}>
    <Seo seo={seoData?.home?.data?.attributes?.seo} />
    {/* TODO: remove once the form component accepts props like isSingleElementOnPage for Contact page (to apply custom padding because of the fixed header) */}
    <div className="pointer-events-none h-[69px] w-full bg-[#6C6E77]" />
  </Layout>
);

export default Contact;
